import type { LibInput } from './base-datetime';
import { isDateStr, localeSettings } from './base-datetime';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

/**
 * Увеличивает или уменьшает дату на заданное кол-во дней
 * @param timestamp - дата в ms
 * @param changeDays - +/- кол-во дней
 */
function changeDATE(timestamp: null | LibInput, changeDays: number, template?: string): Dayjs | null {
    if (timestamp == null) return null;
    if (changeDays === 0) return dayjs(timestamp, template);
    if (changeDays > 0) {
        return dayjs(timestamp, template).add(changeDays, 'days');
    } else {
        return dayjs(timestamp, template).subtract(changeDays * -1, 'days');
    }
}

/**
 * Форматирует TIMESTAMP под DATE по формату
 * @param timestamp - дата
 * @param template - формат шаблона
 * @param changeDays - +/- кол-во дней
 * @param inputTemplate формат шаблона взодной строки
 */
export function formatTStoDATE(
    timestamp: LibInput | DateStr,
    template?: string,
    changeDays?: number,
    inputTemplate?: string
): string;
export function formatTStoDATE(timestamp: null, template?: string, changeDays?: number, inputTemplate?: string): null;
export function formatTStoDATE(
    timestamp: LibInput | DateStr,
    template: string = localeSettings.dateFormat,
    changeDays?: number,
    inputTemplate?: string
): string | null {
    if (!inputTemplate && isDateStr(timestamp)) {
        inputTemplate = localeSettings.serverDateFormat;
    }
    return changeDATE(timestamp, changeDays || 0, inputTemplate)?.format(template) || null;
}

/**
 * Форматирует TIMESTAMP под DATETIME по формату
 * @param timestamp - дата
 * @param template - формат шаблона
 * @param changeDays - +/- кол-во дней
 */
export function formatTStoDATETIME(
    timestamp: LibInput | null,
    template: string = localeSettings.dateTimeFormat,
    changeDays?: number
): string | null {
    return changeDATE(timestamp, changeDays || 0)?.format(template) || null;
}

/**
 * Форматирует TIMESTAMP под DATE формат DD/MM/YYYY
 * @param params - объект с value-число или params-число
 */
export function dateFormatter(params: number | string | { value?: number | string | null } | null): string | null {
    let val: number | string | null;
    if (params && typeof params === 'object') val = params.value ?? null;
    else val = params;
    if (!val) return null;
    if (typeof val === 'number') return formatTStoDATE(val, localeSettings.dateFormat);
    if (isDateStr(val)) return formatTStoDATE(val, localeSettings.dateFormat);
    return val;
}

/**
 * Форматирует TIMESTAMP под DATE формат DD/MM/YYYY HH:mm
 * @param params - объект с value-число или params-число
 */
export function datetimeFormatter(params: number | string | { value?: number | string | null } | null): string | null {
    let val: number | string | null;
    if (params && typeof params === 'object') val = params.value ?? null;
    else val = params;
    if (!val) return null;
    if (typeof val === 'number') return formatTStoDATETIME(val, localeSettings.dateTimeFormat);
    return val;
}

// region Возвращаем по date день виде объекта
export function getFieldDayByData(date: string | number | null, field?: string, template?: string) {
    if (!date) return;
    const dateFormatted = typeof date === 'string' ? date : formatTStoDATE(date, template);
    return {
        date: date,
        name: dateFormatted,
        label: dateFormatted,
        field: `${field ? field + '_' : ''}date_day_${date}`,
    };
}
